import React, { useContext, useEffect } from "react";
import { FiAlertCircle, FiCheck } from "react-icons/fi";
import { Link, useSearchParams } from "react-router-dom";
import PageMeta from "./PageMeta";
import { CartContext } from "./CartContext";
import "../css/paysuccess.css";

export default function PaymentStatus() {
  const [params] = useSearchParams();
  const successful = params.get("state") === "success";
  const { clearCart } = useContext(CartContext);
  useEffect(() => {
    if (successful) clearCart();
  }, [successful, clearCart]);
  return (
    <main className="payment-success-page">
      <PageMeta title={successful ? "Payment successful" : "Payment cancelled"} />
      <section className="payment-success">
        <div className="payment-success__shell"><div className="payment-success__card">
          <div className="payment-success__mark" aria-hidden="true">{successful ? <FiCheck /> : <FiAlertCircle />}</div>
          <p className="payment-success__eyebrow">{successful ? "Payment complete" : "Payment not completed"}</p>
          <h1>{successful ? "Thank you—your payment was successful." : "Your payment was cancelled."}</h1>
          <p className="payment-success__lead">{successful ? "Your order has been received. A confirmation will be sent to the email used at checkout." : "No completed payment was recorded. You can return to your cart or contact us if you need help."}</p>
          <div className="payment-success__actions"><Link className="payment-success__primary" to="/shop">Continue shopping</Link><Link className="payment-success__secondary" to="/contact">Contact us</Link></div>
        </div></div>
      </section>
    </main>
  );
}
